import {createApp} from 'vue'
import App from './App.vue'
import store from './store';
import router from './router'
import VueCookies from 'vue3-cookies'
import VueLoading from 'vue-loading-overlay';
import marketPartnerCommon from './assets/js/marketPartnerCommon'
import mitt from 'mitt';

const emitter= mitt();

createApp(App)
.use(store)
.use(router)
.use(marketPartnerCommon)
.use(VueCookies)
.use(VueLoading)
.provide('emitter', emitter)
.mount('#app')
